import { render, staticRenderFns } from "./ac-card-collection.vue?vue&type=template&id=1a3a564b&"
import script from "./ac-card-collection.vue?vue&type=script&lang=js&"
export * from "./ac-card-collection.vue?vue&type=script&lang=js&"
import style0 from "./ac-card-collection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports